import * as API from "../../api"
import * as ActionTypes from "../action-types";
import { REDUX } from '../../../constants'

/**
 * ThirdParty Library
 */
 import {
    message
} from 'antd'
// import { subscribeWS } from "../../websocket";

import {
    add_rule_in_rule_template_success
} from './ruleTemplates'

/**
 * Get Geofence
 */

export const get_rule_request = ruleid => dispatch => {
    

    API
    .getRuleInfoByRULEID(ruleid)
    .then(info => {
        
        try {
            const {
                rule
            } = info

            dispatch(get_rule_success(rule))


        } catch(err) {
            message.error('Error in getting rules. Refresh page?')
        }

    })
}

const get_rule_success = (rule) => {
    return {
        type: ActionTypes.GET_RULE,
        rule
    };
}

/**
 * Get Rules
 */

 export const get_rules_request = ruleids => dispatch => {

    let ruleidBatch = []

    ruleids.map((vid, index) => {

        ruleidBatch.push(vid)

        if( 
            (index+1) % REDUX.REDUX_RULE_BATCH_GET_SIZE === 0
            ||
            index+1 === ruleids.length
        ) {
            dispatch(batch_get_rules_request(ruleidBatch))
            ruleidBatch = []
        }

        return null
    })
 }

/**
 * Batch Get rule
 */
 export const batch_get_rules_request = ruleids => dispatch => {

    API
    .getRuleInfoBatch(ruleids)
    .then(info => {

        try {
            const {
                rules
            } = info

            dispatch(batch_get_rules_success(rules))


        } catch(err) {
            message.error('Error in batch getting rules. Refresh page?')
        }

    })
}

const batch_get_rules_success = (rules) => {
    return {
        type: ActionTypes.GET_RULES,
        rules
    };
}

/**
 * Set Selected Rule
 */
 export const set_selected_rule_request = (ruleid) => dispatch => {
    dispatch(set_selected_rule_success(ruleid))
}

const set_selected_rule_success = (ruleid) => {
    return {
        type: ActionTypes.SET_SELECTED_RULE_RULEID,
        ruleid
    }
}

/**
 * Clear Selected Rule
 */
export const clear_selected_rule_request = () => dispatch => {
    dispatch(clear_selected_rule_success())
}

const clear_selected_rule_success = () => {
    return {
        type: ActionTypes.CLEAR_SELECTED_RULE_RULEID
    }
}

export const get_rule_param_request = () => dispatch => {
    API
    .getRuleParam()
    .then(info => {

        const { msg, status, ruleParams } = info

        if(status === 200) {
            dispatch(get_rule_params_success(ruleParams))
        } else if(status === 401) {
            message.warning(`Failed in getting rule param. Error: ${msg}`)
        } else {
            message.warning('Failed in creating rule. Retry?')
        }

    })
}

const get_rule_params_success = (ruleParams) => {
    return {
        type: ActionTypes.GET_RULE_PARAMS,
        ruleParams
    }
}

export const create_rule_request = (items, cb = () => {}) => dispatch => {
    API
    .createRule(items)
    .then(info => {

        const { msg, status, rule } = info

        if(status === 200) {
            dispatch(create_rule_success(rule))
            dispatch(add_rule_in_rule_template_success(rule.ruletid, rule.ruleid))
            cb()
        } else if(status === 401) {
            message.warning(`Failed in getting rule. Error: ${msg}`)
        } else {
            message.warning('Failed in creating rule. Retry?')
        }

    })
}

const create_rule_success = (rule) => {
    return {
        type: ActionTypes.CREATE_RULE,
        rule
    }
}

export const update_rule_request = (items, cb = () => {}) => dispatch => {
    API
    .updateRule(items)
    .then(info => {

        const { msg, status, rule } = info

        if(status === 200) {
            dispatch(update_rule_success(rule))
            cb()
        } else if(status === 401) {
            message.warning(`Failed in getting rule param. Error: ${msg}`)
        } else {
            message.warning('Failed in creating rule. Retry?')
        }

    })
}

const update_rule_success = (rule) => {
    return {
        type: ActionTypes.EDIT_RULE,
        rule
    }
}

export const get_rule_notification_request = (notification) => dispatch => {
    console.log(dispatch, notification)
    // API
    // .getVehicleEventLogByTimeFrameSync(
    //     vid,
    //     startTime,
    //     endTime
    // )
    // .then(info => console.log(info))
}

// const get_rule_notification_success = ()